import { formatDistanceToNowStrict, formatDistanceToNow } from 'date-fns'

export const getAutoApprovalDateText = (
  client_approval_deadline: string | null | undefined
): string | null => {
  const deadline = client_approval_deadline

  if (!deadline) return null
  const distanceToNow = formatDistanceToNowStrict(new Date(deadline), {
    addSuffix: false,
    unit: 'day',
    roundingMethod: 'round',
  })

  const expiryInDays = +(distanceToNow.match(/\d+/) || [])[0]!

  if (expiryInDays === 0) {
    const distance = formatDistanceToNow(new Date(deadline), {
      addSuffix: true,
    })
    return `Review cycle expires ${distance.replace('hours', 'hrs')}`
  } else if (expiryInDays === 1) {
    return 'Review cycle expires tomorrow'
  } else if (expiryInDays <= 7) {
    return `Review cycle expires in ${expiryInDays} days`
  } else {
    return null
  }
}
